module.exports = __webpack_public_path__ + "img/AIANALYST450px.b3d60de8.png";